import React, { Component } from "react";
import Loading from './loading';
import Nav from 'react-bootstrap/Nav';
import { Fade } from 'react-reveal';
 
class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            menuerror: null,
            menuisLoaded: false,
            menuitems: []
        };
    }

    componentDidMount() {
        fetch("/json/categories.json?v=" + process.env.REACT_APP_SITE_VERSION)
            .then(res => res.json())
            .then(
            (result) => {
                this.setState({
                isLoaded: true,
                items: result
                });
            },
            (error) => {
                this.setState({
                isLoaded: true,
                error
                });
            }
        )

        fetch("/json/content.json?v=" + process.env.REACT_APP_SITE_VERSION)
            .then(res => res.json())
            .then(
            (result) => {
                this.setState({
                menuisLoaded: true,
                menuitems: result
                });
            },
            (menuerror) => {
                this.setState({
                menuisLoaded: true,
                menuerror
                });
            }
        )
    }

    render() {
        const { error, isLoaded, items } = this.state;
        const { menuerror, menuisLoaded, menuitems } = this.state;
        if (error || menuerror) {
          return <div>Error: {error.message}</div>;
        } else if (!isLoaded || !menuisLoaded) {
          return <Loading />;
        } else {
            return (
                <>
                    <aside className="sticky-sidebar">
                        <Fade right>
                            <section className="sidebarmenu">
                                <h3>Mortgage</h3>
                                <Nav className="flex-column">
            
                                    {
                                        items.filter(menuitem => menuitem.isActive === true).map((menuitem, i) => {
                                            return (
                                                <Nav.Item className={menuitem.name === this.props.page ? 'hasChild' : ''} key={i}>
                                                    <Nav.Link href={menuitem.guid}>{menuitem.name}</Nav.Link>

                                                    {
                                                        menuitem.name === this.props.page && (
                                                            <Nav className="flex-column nav-link">
                                                            {
                                                                
                                                                menuitems.filter(contentitems => contentitems.category === menuitem.name)
                                                                .map((contentitem, b) => {
                                                                        return (
                                                                        <Nav.Item key={b}>
                                                                            <Nav.Link href={contentitem.permalink}>{contentitem.name}</Nav.Link>
                                                                        </Nav.Item>
                                                                        )
                                                                    }
                                                                )
                                                            }
                                                            </Nav>
                                                        )
                                                    }

                                                </Nav.Item>
                                            );
                                        })
                                    }
                                </Nav>
                            </section>
                        </Fade>
                    </aside>
                </>
            );
        }
    }
}
 
export default Sidebar;